(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

  function openSideCart() {
    var trigger = document.querySelector('.push_side[data-id="#js_cart_popup"]') ||
                  document.querySelector('.minicart .push_side');
    var popup = document.getElementById('js_cart_popup');

    if (trigger && !trigger.classList.contains('active')) {
      trigger.click();
    }

    if (popup && !popup.classList.contains('act_opened')) {
      if (trigger) trigger.classList.add('active');
      popup.classList.add('act_opened');
      document.documentElement.classList.add('pside_opened');
    }
  }

  function updateCartCount(count) {
    document.querySelectorAll('.js-cart-count,[data-cart-count],[data-cart-item-count],.cart-count,.CartCount,.wm-cart-count,#wmCartCount').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
      if (el.hasAttribute('data-js-cart-count')) el.setAttribute('data-js-cart-count', count);
    });
  }

  function openCartDrawer(addResponse) {
    openSideCart();

    document.body.addEventListener('contentUpdated', function () {
      openSideCart();
    }, { once: true });

    try {
      if (addResponse && addResponse.sections && addResponse.sections.minicart) {
        document.body.dispatchEvent(new CustomEvent('ajax:addToCart', {
          detail: { response: addResponse }
        }));
      } else {
        fetch(root + '?sections=minicart')
          .then(function (r) { return r.json(); })
          .then(function (sections) {
            try {
              document.body.dispatchEvent(new CustomEvent('drawer:Minicart', {
                detail: { response: { sections: sections } }
              }));
            } catch (e) {}
          })
          .catch(function () {});
        document.body.dispatchEvent(new CustomEvent('update:miniCart', { bubbles: true }));
      }
    } catch (e) {}

    setTimeout(openSideCart, 400);

    fetch(root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () {});
  }

  function add(options) {
    var variantId = options.variantId;
    var quantity = options.quantity || 1;
    var onError = options.onError || function () {};

    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
        sections: 'minicart',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d.status) {
          onError(d.description || 'Could not add to cart. Please try again.');
          return d;
        }
        openCartDrawer(d);
        return d;
      })
      .catch(function () {
        onError('Could not add to cart. Please try again.');
      });
  }

  window.WmPdpCart = {
    openSideCart: openSideCart,
    updateCartCount: updateCartCount,
    openCartDrawer: openCartDrawer,
    add: add
  };
})();
